import React from 'react'
import { ActivityIndicator } from 'react-native'
import { getTheme } from '@hedgit/lib/theme/index'

import { Container } from './styled'

const theme = getTheme()
const { colors } = theme

const LoadingScreen = () => (
  <Container>
    <ActivityIndicator color={colors.primary} style={{ flex: 1 }} />
  </Container>
)

export default LoadingScreen
